import React from "react";
import { Badge as Container } from "../../styles-components/Texts";

export default function Badge({ type = null, circle = false, transform = null, children, ...rest }) {
  function handleType(type) {
    switch (type) {
      case "success":
        return { bgColor: "--dark-green" };
      case "info":
        return { bgColor: "--blue" };
      case "danger":
        return { bgColor: "--red" };
      case "warning":
        return { bgColor: "--yellow" };
      case "inative":
        return { bgColor: "--register-gray" };
    }
  }

  return (
    <>
      {type !== null ? (
        <Container {...rest} {...handleType(type)} circle={circle} transform={transform}>{children}</Container>
      ) : (
        <Container {...rest} circle={circle} transform={transform}>{children}</Container>
      )}
    </>
  );
}
